// components/Sidebar.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "./AppIcon";

const Sidebar = ({ isOpen, onClose, user = null, isMobile }) => {
  const location = useLocation();

  const navigationItems = [
    { label: "Dashboard", path: "/dashboard", icon: "LayoutDashboard" },
    { label: "Create Event", path: "/create-event", icon: "Plus" },
    { label: "Events", path: "/events", icon: "Calendar" },
    { label: "Analytics", path: "/analytics", icon: "BarChart3" },
    // { label: "Spend-Wise Dashboard", path: "/spend-wise-dashboard", icon: "LayoutDashboard" },
    { label: "All Expenses", path: "/expenses", icon: "ListChecks" },
    { label: "Add Expense", path: "/add-expense", icon: "Plus" },
    { label: "Budgets", path: "/budgets", icon: "Target" },
    // { label: "Reports", path: "/reports", icon: "BarChart3" },
    { label: "Profile", path: "/profile", icon: "User" },
    // { label: "Settings", path: "/settings", icon: "Settings" },
    { label: "Help", path: "/help", icon: "HelpCircle" },
  ];

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const handleNavItemClick = () => {
    // Close sidebar when nav item is clicked (especially useful on mobile)
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Mobile Overlay */}
      {isMobile && isOpen && (
        <div
          className="fixed inset-0 top-16 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed left-0 top-16 bottom-0 w-64 bg-card border-r border-border transition-transform duration-300 ease-in-out ${
          isOpen
            ? "translate-x-0"
            : isMobile
            ? "-translate-x-full"
            : "translate-x-0" // Always visible on desktop
        } ${
          isMobile ? "z-50" : "z-30" // Higher z-index on mobile, lower on desktop
        }`}
        role="navigation"
        aria-label="Main navigation"
      >
        <div className="flex flex-col h-full overflow-hidden">
          {/* Navigation Items */}
          <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                onClick={handleNavItemClick}
                className={`flex items-center space-x-3 px-4 py-3 rounded-md text-sm font-medium transition-micro group ${
                  isActivePath(item?.path)
                    ? "bg-primary text-primary-foreground shadow-sm"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted"
                }`}
                aria-current={isActivePath(item?.path) ? "page" : undefined}
              >
                <Icon
                  name={item?.icon}
                  size={20}
                  className={`${
                    isActivePath(item?.path)
                      ? "text-primary-foreground"
                      : "text-muted-foreground group-hover:text-foreground"
                  }`}
                />
                <span className="truncate">{item?.label}</span>
              </Link>
            ))}
          </nav>

          {/* Sidebar Footer */}
          {user && (
            <div className="px-4 py-4 border-t border-border">
              <div className="flex items-center space-x-3 px-4 py-2">
                <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                  <span className="text-sm font-medium text-primary-foreground">
                    {user?.name ? user?.name?.charAt(0)?.toUpperCase() : "U"}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground truncate">
                    {user?.name || "User"}
                  </p>
                  <p className="text-xs text-muted-foreground truncate">
                    {user?.email || "user@example.com"}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
